<template>
    <div id="personal-details" class="personal-details-wrapper scroll-mt- mt-8">
        <HeadingBarComponent :step="1" />
        <div class="md:flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Personal Information</h3>
                <InputComponent label="Title" :value="submission.personal_details.title" />
                <InputComponent label="First Name" :value="submission.personal_details.first_name" />
                <InputComponent label="Middle Name(s)" :value="submission.personal_details.middle_name" />
                <InputComponent label="Surname" :value="submission.personal_details.last_name" />
                <InputComponent label="Previous Name" :value="submission.personal_details.previous_name" />
                <HrComponent />
                <InputComponent label="Nationality" :value="submission.personal_details.nationality | country" />
                <InputComponent label="Dual Nationality" :value="submission.personal_details.other_nationality | country" />
                <InputComponent label="Citizenship" :value="submission.personal_details.citizenship | country" />
                <HrComponent />
                <InputComponent label="Date of Birth" :value="submission.personal_details.date_of_birth" />
                <InputComponent label="Number of Dependents" :value="submission.personal_details.number_of_dependents" />
                <HrComponent />
                <InputComponent label="Tax Residence Jurisdiction" :value="submission.personal_details.tax_residence_jurisdiction | country" />
                <InputComponent label="TIN" :value="submission.personal_details.tin" />
                <HrComponent />

                <h3 class="mb-4">Contact Details</h3>
                <InputComponent label="Email Address" :value="submission.email" />
                <InputComponent label="Landline" :value="submission.personal_details.telephone_international_dialling_code.international_dialling_code + submission.personal_details.telephone_no" />
                <InputComponent label="Mobile" :value="submission.personal_details.mobile_international_dialling_code.international_dialling_code + submission.personal_details.mobile_no" />
                <HrComponent />
            </div>
            <!-- Right Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Address</h3>
                <InputComponent label="Street Address" :value="currentAddress != undefined ? currentAddress.street_address : ''" />
                <InputComponent label="Town/City" :value="currentAddress != undefined ? currentAddress.city : ''" />
                <InputComponent label="Post Code" :value="currentAddress != undefined ? currentAddress.postcode : ''" />
                <InputComponent label="Country" :value="currentAddress != undefined ? currentAddress.country : '' | country" />
                <InputComponent label="Duration at Address (years)" :value="currentAddress != undefined ? currentAddress.duration_at_address : ''" />
                <HrComponent />

                <h3 class="mb-4">Previous Address</h3>
                <InputComponent label="Street Address" :value="previousAddress != undefined ? previousAddress.street_address : ''" />
                <InputComponent label="Town/City" :value="previousAddress != undefined ? previousAddress.city : ''" />
                <InputComponent label="Post Code" :value="previousAddress != undefined ? previousAddress.postcode : ''" />
                <InputComponent label="Country" :value="previousAddress != undefined ? previousAddress.country : '' | country" />
                <InputComponent label="Duration at Address (years)" :value="previousAddress != undefined ? previousAddress.duration_at_address : ''" />
                <HrComponent />

                 <h3 class="mb-4">Mailing Address</h3>
                <InputComponent label="Street Address" :value="mailingAddress != undefined ? mailingAddress.street_address : ''" />
                <InputComponent label="Town/City" :value="mailingAddress != undefined ? mailingAddress.city : ''" />
                <InputComponent label="Post Code" :value="mailingAddress != undefined ?mailingAddress.postcode : ''" />
                <InputComponent label="Country" :value="mailingAddress != undefined ? mailingAddress.country : '' | country" />
                <InputComponent label="Duration at Address (years)" :value="mailingAddress != undefined ? mailingAddress.duration_at_address : ''" />
                <HrComponent />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';

export default {
    name: "PersonalDetailsComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent
    },
    computed: {
        ...mapGetters(["submission"]),
        currentAddress(){
            return this.submission.address.filter((address) => address.type == "Current")[0];
        },
        previousAddress(){
            return this.submission.address.filter((address) => address.type == "Previous")[0];
        },
        mailingAddress(){
            return this.submission.address.filter((address) => address.type == "Mailing")[0];
        }
    },
    data: function () {
        return {
            isLoading: false,
        };
    },
    methods: {
        // ...mapActions(["doLogout"]),
    },
};
</script>
